import { postMessageToIframeParent } from "./iframeMessaging.ts";

const iframeCopy = (content: string) => {
  postMessageToIframeParent({ type: "copy", content: content });
};

export default iframeCopy;
